// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"486":"039b4868188859a8","875":"10d256567272d386"}[chunkId] + ".js";
};